;(function () {
  'use strict'

  angular
    .module('contrast.servers')
    .directive('serverLink', ['UserService', serverLink])

  function serverLink(UserService) {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        server: '='
      },
      link: function (scope) {
        scope.organization = UserService.getCurrentOrganization()
      },
      templateUrl: 'views/server-link.html'
    }
  }
})()
